import React, { useState } from 'react';
import { User } from 'lucide-react';

/**
 * Reusable Avatar component with error handling fallback.
 * If the image fails to load, it displays the user's initials or a default icon.
 */
const Avatar = ({ src, alt, name, className = "w-full h-full" }) => {
    const [hasError, setHasError] = useState(false);

    // Get initials from name (max 2 characters)
    const getInitials = (userName) => {
        if (!userName) return '';
        const parts = userName.trim().split(' ');
        if (parts.length >= 2) {
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }
        return parts[0][0]?.toUpperCase() || '';
    };

    const initials = getInitials(name);

    if (src && !hasError) {
        return (
            <img 
                src={src} 
                alt={alt || "Avatar"} 
                className={`${className} object-cover`}
                onError={() => setHasError(true)}
            />
        );
    }

    if (initials) {
        return (
            <div className={`${className} flex items-center justify-center font-bold text-xs uppercase tracking-tighter`} style={{ background: 'var(--bg-tertiary)', color: 'var(--text-primary)' }}>
                {initials}
            </div>
        );
    }

    return (
        <div className={`${className} flex items-center justify-center`} style={{ background: 'var(--bg-tertiary)' }}>
            <User className="w-1/2 h-1/2" style={{ color: 'var(--text-secondary)' }} />
        </div>
    );
};

export default Avatar;
